import React from "react";
import { useNavigate } from "react-router";
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import { exportar } from '../../utils/Exportar';

import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function CamposToolbar(props) {
  const navigate = useNavigate();

  return (
    <>
      <Toolbar
        sx={{
          boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
          paddingTop: 1,
          paddingBottom: 1,
          justifycontent: 'space-between',
          borderBottom: 1,
          borderColor: '#ddd',
          backgroundColor: '#fff',
          margin: '8px 8px 0 8px',
          borderTopLeftRadius: '5px',
          borderTopRightRadius: '5px',
        }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifycontent: 'flex-start',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography
            variant="h6"
            id="tableTitle"
            component="div"
            sx={{
              marginRight: '20px',
              flexGrow: { xs: 1, sm: 0 },
            }}>
            Dados do Documento
          </Typography>
          {
            props.documento.situacao_variavel !== ''
            ? (<Chip
              label={props.documento.situacao_nome}
              color={props.documento.situacao_variavel}
            />)
            : (<></>)
          }
        </Box>

        <Box
          sx={{
            flex: 1,
            display: { xs: 'none', sm: 'flex' },
            justifyContent: 'flex-end',
            alignItems: 'right',
            gap: 2,
          }}
        >
          <Stack direction="row" spacing={1} justifycontent="flex-end">
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              size="large"
              onClick={()=>{
                navigate(`/`);
              }}>
              Voltar
            </Button>

            <Button
              variant="contained"
              startIcon={<TextSnippetIcon />}
              size="large"
              onClick={()=>{exportar(props.documentoUUID)}}>
              Exportar
            </Button>

            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              size="large"
              color="success"
              type="submit">
              Salvar
            </Button>
          </Stack>
        </Box>

      </Toolbar>

      <Fab
        color="success"
        aria-label="fab-add"
        type="submit"
        sx={{
          position: 'absolute',
          bottom: 35,
          right: 25,
          display: { xs: 'flex', sm: 'none' },
        }}>
        <SaveIcon />
      </Fab>

      <Fab
        color="azul"
        aria-label="fab-export"
        onClick={()=>{exportar(props.documentoUUID)}}
        sx={{
          position: 'absolute',
          bottom: 35,
          right: 95,
          display: { xs: 'flex', sm: 'none' },
        }}>
        <TextSnippetIcon />
      </Fab>

      <Fab
        variant="outlined"
        aria-label="fab-export"
        onClick={()=>{
          navigate(`/`);
        }}
        sx={{
          position: 'absolute',
          bottom: 35,
          left: 35,
          display: { xs: 'flex', sm: 'none' },
        }}>
        <ArrowBackIcon />
      </Fab>
    </>
  );
}
